export default __webpack_public_path__ + "static/media/button_deposit.3d833e12.svg";